export {
  CarouselArrowPosition,
  CarouselComponent,
  CarouselImage,
  CarouselScrollBehaviour,
} from './carousel.component';
